import React from 'react';
import ContractDetails from '../components/contracts/ContractDetails';

const ContractDetailsPage = () => {
  return (
    <div className="container mx-auto p-4">
      <ContractDetails />
    </div>
  );
};


export default ContractDetailsPage;